import { CurrentRefinements } from 'react-instantsearch'

const FilterLabels = () => {
  return (
    <CurrentRefinements
      transformItems={(items) =>
        items.flatMap((item) =>
          item.refinements.map((refinement) => {
            return {
              ...item,
              refinements: [refinement],
              label: refinement.attribute,
            }
          }),
        )
      }
      classNames={{
        root: 'flex flex-row flex-wrap justify-start content-between',
        list: 'flex flex-row flex-wrap justify-start content-between gap-[8px]',
        item: 'italic md:text-[15px] text-sm h-[32px] rounded-[10px] shadow-[0px_1px_2px_rgba(0,0,0,0.25)] focus:outline-none focus:border-none bg-black text-white md:h-[29px] flex justify-between items-center md:w-fit p-[4px]',
        category: '',
        label: 'hidden',
        delete: 'p-1',
      }}
    />
  )
}

export default FilterLabels
